module.exports = __webpack_public_path__ + "static/img/gpt3.3c772001.jpg";